module.exports = __webpack_public_path__ + "static/media/edit.6537e153.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/edit.png
// module id = 2234
// module chunks = 0